import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Result from './Result';
import {
    customerShape,
    transactionShape
} from '../../../../utils/propTypes';

export default class Section extends Component {
    static propTypes = {
        inputValue: PropTypes.string,
        onSelectResult: PropTypes.func,
        propGenerator: PropTypes.func.isRequired,
        results: PropTypes.arrayOf(
            PropTypes.oneOfType([
                customerShape,
                transactionShape
            ])
        ),
        sectionTitle: PropTypes.string.isRequired
    };

    render() {
        if (this.props.results.length) {
            return (
                <div className="section">
                    <div className="section-title">
                        {this.props.sectionTitle}
                    </div>
                    <div className="section-results-list">
                        {this.props.results.map((result) => <Result
                            key={JSON.stringify(result)}
                            inputValue={this.props.inputValue}
                            onSelectResult={this.props.onSelectResult}
                            {...this.props.propGenerator(result) }
                        />)}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}
